import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../../assets/images/brand/ArdillaLabsLogoWhite.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from "@fortawesome/free-solid-svg-icons";

const pages = [
    { name: "Home", path: "root" },
    { name: "About Us", path: "about" },
    { name: "Services", path: "services" },
    { name: "Clients", path: "clients" },
    { name: "Contact", path: "contact" }
];

const Navbar = ({ toggleSidebar }) => {
    const navigate = useNavigate();

    const toggleStart = () => navigate('/auth/login');

    return (
        <>
            <div className={styles.navContainer}>
                <div className={styles.navBar}>
                    <div className={styles.logoSec}>
                        <NavLink to={'/'}>
                            <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                        </NavLink>
                    </div>
                    <div className={styles.pagesList}>
                        <ul className={styles.navList} style={{ paddingLeft: '0' }}>
                            {pages.map(({ name, path }) => (
                                <li key={name}>
                                    <button
                                        className={styles.navLink}
                                        onClick={() => {
                                            const section = document.getElementById(path);
                                            if (section) {
                                                section.scrollIntoView({ behavior: "smooth" });
                                            }
                                        }}
                                    >
                                        {name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.rightSec}>
                        <button type="button" className={styles.loginBtn}
                            onClick={() => {
                                const section = document.getElementById('contact');
                                if (section) {
                                    section.scrollIntoView({ behavior: "smooth" });
                                }
                            }}
                        >Get Started</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;